import { Component, inject, input, OnInit, signal } from '@angular/core';
import { UsersService } from '@ubie/core';

@Component({
  selector: 'acl-activate-user',
  standalone: false,
  templateUrl: './activate-user.component.html',
  styleUrl: './activate-user.component.scss',
})
export class ActivateUserComponent implements OnInit {
  private readonly userService = inject(UsersService);

  readonly key = input.required<string>();
  readonly isSuccess = signal(false);

  ngOnInit(): void {
    this.activateUser();
  }

  activateUser(): void {
    this.userService.activate(this.key(), null).subscribe({
      next: () => this.isSuccess.set(true),
      error: () => this.isSuccess.set(false),
    });
  }

  goToLogin(): void {
    window.location.href = '/login';
  }
}
